export default __webpack_public_path__ + "static/media/tablet-doc-2.71c97585.png";